'use client'

import { useRef, useState } from 'react'
import axios from 'axios'
import { Mic, MicOff } from 'lucide-react'

export default function VoiceSearch({ onResult }: { onResult: (text: string) => void }) {
  const [isListening, setIsListening] = useState(false)
  const mediaRecorderRef = useRef<MediaRecorder | null>(null)
  const chunks = useRef<Blob[]>([])
  const streamRef = useRef<MediaStream | null>(null)
  const silenceTimer = useRef<NodeJS.Timeout | null>(null)

  const startRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true })
      streamRef.current = stream

      const mediaRecorder = new MediaRecorder(stream)
      mediaRecorderRef.current = mediaRecorder
      chunks.current = []

      mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          chunks.current.push(e.data)
        }
      }

      mediaRecorder.onstop = async () => {
        clearTimeout(silenceTimer.current!)
        stopStream()

        const blob = new Blob(chunks.current, { type: 'audio/webm' })

        try {
          const buffer = await blob.arrayBuffer()

          const response = await axios.post('https://api.deepgram.com/v1/listen', buffer, {
            headers: {
              Authorization: `Token ${process.env.NEXT_PUBLIC_DEEPGRAM_API_KEY}`,
              'Content-Type': 'audio/webm'
            }
          })

          const transcript = response.data.results.channels[0].alternatives[0].transcript
          if (transcript) {
            onResult(transcript)
          }
        } catch (error) {
          console.error('Deepgram API error:', error)
        } finally {
          setIsListening(false)
        }
      }

      mediaRecorder.start()
      setIsListening(true)

      silenceTimer.current = setTimeout(() => {
        stopRecording()
      }, 5000)
    } catch (err) {
      console.error('Microphone access denied or failed:', err)
      setIsListening(false)
    }
  }

  const stopRecording = () => {
    mediaRecorderRef.current?.stop()
  }

  const stopStream = () => {
    if (streamRef.current) {
      streamRef.current.getTracks().forEach((track) => track.stop())
      streamRef.current = null
    }
  }

  const toggleListening = () => {
    if (isListening) {
      stopRecording()
    } else {
      startRecording()
    }
  }

  return (
    <div className="relative">
      <div onClick={toggleListening}>
        {isListening ? (
          <MicOff
            size={22}
            color="#dba4bc"
          />
        ) : (
          <Mic
            size={22}
            color="#ccc"
          />
        )}
      </div>

      {isListening && (
        <div className="listing-loader">
          <span className="stroke"></span>
          <span className="stroke"></span>
          <span className="stroke"></span>
          <span className="stroke"></span>
          <span className="stroke"></span>
          <span className="stroke"></span>
          <span className="stroke"></span>
        </div>
      )}
    </div>
  )
}
